export const CARD_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELED: 'canceled',
};

export const CARD_TYPES = Object.freeze({
  VIRTUAL: 'virtual',
  PHYSICAL: 'physical',
});
